import styled from "@emotion/styled";
import { Autocomplete, css, FormControl, InputLabel, TextField, Tooltip } from "@mui/material/";
import { DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MuiColorInput } from "mui-color-input";
import { NumberFormatBase, NumericFormat } from "react-number-format";

const propsCampoDeTextoNaoEncaminhadas = new Set([
  "typeNumber",
  "$mostrarSetasInputNumerico",
  "$fundoTransparente",
  "ocultarSetas",
  "maxlength",
]);

const propsFormatoNumericoNaoEncaminhadas = new Set([
  "thousandSeparator",
  "decimalSeparator",
  "decimalScale",
  "fixedDecimalScale",
  "prefix",
  "suffix",
  "sufix",
  "allowEmptyFormatting",
]);

export const CampoDeTextoBase = styled(TextField, {
  shouldForwardProp: (prop) => !propsCampoDeTextoNaoEncaminhadas.has(prop),
})`
  width: 100%;
  height: 56px;

  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: ${(props) => (props.value !== "" ? `16px;` : "16px;")};
    ${(props) => props.value && `padding-top: 7px;`};
  }

  & .MuiInputLabel-root.Mui-error {
    color: #f44336 !important;
    -webkit-text-fill-color: #f44336 !important;
  }

  & .MuiInputLabel-root.Mui-error.MuiInputLabel-shrink {
    color: #f44336 !important;
    -webkit-text-fill-color: #f44336 !important;
  }

  & .MuiInputLabel-root.Mui-focused.Mui-error {
    color: #f44336 !important;
    -webkit-text-fill-color: #f44336 !important;
  }
  label.Mui-error {
    color: #f44336 !important;
    -webkit-text-fill-color: #f44336 !important;
  }

  input {
    padding-left: 2px;
    padding-top: 12px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  div {
    height: 56px;
  }

  .Mui-disabled {
    cursor: ${({ typeNumber }) => typeNumber === false && "not-allowed"};
    opacity: ${({ typeNumber }) => (typeNumber === true ? 1 : 1)};
    color: ${({ theme }) => theme.cores.corInputDisabled};
    -webkit-text-fill-color: ${({ theme }) => theme.cores.corInputDisabled};
  }

  /* ${(props) =>
    !props.theme.temaDarkAtivo &&
    `
      opacity: 1;
      -webkit-text-fill-color: ${({ theme }) => theme.cores.fundoEditar} !important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `}; */

  ${(props) =>
    !props.$mostrarSetasInputNumerico &&
    css`
      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    `}

  ${(props) =>
    props.ocultarSetas &&
    `
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type="number"] {
        -moz-appearance: textfield;
    }
  `}

  .MuiFilledInput-input {
    &:has(input:focus) label {
      padding-top: 0px;
      padding-left: 56px;
    }
  }
`;
export const CampoDeInputNumericoAlternativoBase = styled(TextField)`
  width: 100%;
  height: 56px;

  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: ${(props) => (props.value !== "" || props.value !== null ? `16px;` : "12px;")};
    padding-top: ${(props) => props.value !== "" && props.value !== null && `8px;`};
  }

  input {
    padding-left: 2px;
    padding-top: 19px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  div {
    height: 56px;
  }

  .Mui-disabled {
    cursor: ${({ typeNumber }) => typeNumber === false && "not-allowed"};
    opacity: ${({ typeNumber }) => (typeNumber === true ? 1 : 1)};
    color: ${({ theme }) => theme.cores.corInputDisabled};
    -webkit-text-fill-color: ${({ theme }) => theme.cores.corInputDisabled};
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${(props) =>
    props.ocultarSetas &&
    `
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type="number"] {
        -moz-appearance: textfield;
    }
  `}

  .MuiFilledInput-input {
    &:has(input:focus) label {
      padding-top: 0px;
      padding-left: 56px;
    }
  }
`;

export const CampoDeTextoBaseSelecionarCliente = styled(TextField)`
  width: 100%;
  height: 56px;

  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: ${(props) => (props.value !== "" || props.value !== null ? `16px;` : "12px;")};
    padding-top: ${(props) => props.value !== "" && props.value !== null && `8px;`};
  }

  input {
    padding-left: 2px;
    padding-top: 19px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  .Mui-Disabled {
    ${(props) =>
      !props.theme.temaDarkAtivo &&
      `
      -webkit-text-fill-color: rgba(0, 0, 0, 0.8)!important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `};
  }

  & > div.MuiInputBase-root {
    height: 56px;
    pointer-events: none !important;
  }
`;

export const FormularioCustomizado = styled(FormControl)`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: ${(props) => (props.value !== "" ? `16px;` : "16px;")};
    ${(props) => props.value !== "" && `padding-top: 7px;`};
  }

  input {
    padding-left: 2px;
    padding-top: 19px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  .Mui-disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const InputCustomizado = styled(InputLabel)`
  /* color: ${({ theme, error }) => error && "red"}; */
`;

export const FormularioCustomizadoSelecao = styled(FormControl)`
  width: 100%;
  z-index: 0;
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  ${({ error }) =>
    error &&
    `
    .MuiInput-underline:before {
      border-bottom-color: #f44336 !important;
    }
    .MuiInput-underline:after {
      border-bottom-color: #f44336 !important;
    }
    .MuiInputLabel-root {
      color: #f44336 !important;
    }
    .MuiInputLabel-root.Mui-focused {
      color: #f44336 !important;
    }
  `}

  label {
    padding-left: ${(props) => (props.value !== "" || props.value !== null ? `12px;` : "16px;")};
    padding-top: ${(props) => (props.value ? "6px" : "0px")};
    color: ${({ error, theme }) => (error ? "#f44336" : theme.cores.textoSimples)};
  }

  input {
    padding-left: 12px;
    padding-top: 19px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  .MuiSvgIcon-root {
    color: ${(props) => (props.cor != null ? `rgb(${props.cor})` : null)};
    margin-right: 24px;
  }

  .MuiSelect-select {
    color: ${({ error, theme }) => (error ? "#f44336" : theme.cores.textoSimples)};
  }

  .MuiInputBase-root {
    color: ${({ error, theme }) => (error ? "#f44336" : theme.cores.textoSimples)};

    &.Mui-error {
      color: #f44336;

      & .MuiSelect-select {
        color: #f44336;
      }

      & .MuiInputLabel-root {
        color: #f44336;
      }
    }
  }

  height: 56px;

  div {
    height: 56px;
    padding-top: 12px;
  }

  .Mui-disabled {
    cursor: not-allowed;
    opacity: 0.99;
  }

  .selectInputComInfo {
    > div:first-of-type {
      width: calc(100% - 50px);
    }
    .MuiSvgIcon-root {
      margin-right: 24px;
    }
  }
`;

export const CampoDeDataSemHoraBase = styled(DatePicker)`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  .MuiInputAdornment-root {
    padding-right: 12px;
  }

  label {
    padding-left: ${(props) => (props.value !== "" ? `16px;` : "12px;")};
    ${(props) => props.value !== "" && props.value !== null && `padding-top: 5px;`}
  }

  input {
    padding-left: 2px;
    padding-top: 19px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  .MuiFormHelperText-root.Mui-error {
    color: ${({ theme }) => theme.cores.semanticDanger2};
    font-size: 14px;
    font-weight: bold;
    margin-left: 0;
    margin-right: 0;
  }

  height: 56px;

  div {
    height: 56px;
  }
`;

export const CampoDeDataBase = styled(DateTimePicker)`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  .MuiInputAdornment-root {
    padding-right: 2px;
  }

  label {
    padding-left: ${(props) => (props.value !== "" ? `16px;` : "12px;")};
    ${(props) => props.value !== "" && props.value !== null && `padding-top: 5px;`}
  }

  .MuiInputBase-root {
    padding-top: 17px;
  }

  input {
    /* padding-left: 2px; */
    padding-top: 17px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  .MuiFormHelperText-root.Mui-error {
    color: ${({ theme }) => theme.cores.semanticDanger2};
    font-size: 14px;
    font-weight: bold;
    margin-left: 0;
    margin-right: 0;
  }

  height: 56px;

  div {
    height: 56px;
  }
`;

export const CampoDeTextoBaseAutoComplete = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "finalizadoras" && prop !== "sxMaxHeight100",
})`
  width: 100%;

  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: ${(props) => (props.value !== "" || props.value !== null ? `16px;` : "12px;")};
    padding-top: ${(props) => props.value !== "" && props.value !== null && `8px;`};
  }

  input {
    padding-left: 12px;
    padding-top: 19px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  .MuiInputBase-root {
    min-height: 56px;
    padding-top: 15px;
    height: auto;
  }

  .MuiChip-root {
    background: transparent;
    border: solid 0.5px ${({ theme }) => theme.cores.actionActive};
    span {
      padding: 2px 13px;
      color: ${({ theme }) => theme.cores.actionActive};
    }
    svg {
      font-size: 18px;
    }
    path {
      fill: ${({ theme }) => String(theme.cores.actionActive).replace("1)", "0.4)")};
    }
  }

  .MuiAutocomplete-endAdornment {
    padding-right: ${(props) => (props.finalizadoras ? "0px" : "12px")};
    padding-top: ${(props) => (props.finalizadoras ? "32px" : "0px")};
  }

  @media (max-width: 768px) {
    .MuiInputBase-root {
      padding-top: 25px;
      padding-bottom: 5px;
    }
    .MuiInputBase-root > div {
      margin-top: 0px;
    }
  }

  .Mui-disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const ContainerData = styled(FormularioCustomizado)`
  margin: 0;
  padding: 0;
  background-color: transparent;
`;

export const FormularioCustomizadoMultiSelect = styled(FormularioCustomizadoSelecao)`
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};

  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  // div {
  //   height: min-content;
  //   padding-top: 0px;
  //   margin-top: 8px;
  // }

  .MuiFormControl-root {
    margin-top: -4px;
    height: min-content;
  }

  .Mui-Disabled {
    ${(props) =>
      !props.theme.temaDarkAtivo &&
      `
      -webkit-text-fill-color: rgba(0, 0, 0, 0.9)!important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `};
  }

  ${(props) =>
    props.layoutFix &&
    css`
      .MuiFormControl-root {
        height: auto !important;
      }

      .MuiFormControl-root div {
        padding: 0px;
        margin-top: 3px !important;
        height: min-content !important;
        min-height: 48px;
      }

      .MuiChip-outlined {
        height: min-content;
        min-height: 0px !important;
      }

      .boxChips {
        padding: 10px 0px 8px 0px !important;

        flex-wrap: ${props.chipsMultiline ? "wrap" : "nowrap"};
        display: flex;
        align-items: center;
        overflow-x: ${props.chipsMultiline ? "visible" : "auto"};
      }

      /* Altura máxima para o dropdown */
      .MuiAutocomplete-listbox {
        max-height: 300px !important;
      }

      .MuiPaper-root {
        max-height: 350px !important;
      }

      .MuiChip-root {
        padding-top: 0px;
      }
    `}
`;
export const TextFieldMonetario = styled(TextField)`
  //margin-top: 20px;
  width: 100%;

  .MuiInput-input {
    /* padding-left: 12px; */
    padding-top: 16px;
  }

  .MuiInput-root {
    font-size: 20px;
    font-family: "Source Sans Pro", sans-serif;

    color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
  }

  .MuiTypography-root {
    font-size: 20px;
    font-family: "Source Sans Pro", sans-serif;

    color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
  }

  .MuiInputBase-root {
    padding: 5px 0;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
export const TextFieldMonetarioPadronizado = styled(TextField)`
  width: 100%;
  height: 56px;

  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: ${(props) => (props.value !== "" || props.value !== null ? `16px;` : "12px;")};
    padding-top: ${(props) => props.value !== "" && props.value !== null && `8px;`};
  }

  input {
    padding-left: 2px;
    padding-top: 19px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  div {
    height: 56px;
  }

  .Mui-disabled {
    cursor: ${({ typeNumber }) => typeNumber === false && "not-allowed"};
    opacity: ${({ typeNumber }) => (typeNumber === true ? 1 : 0.7)};
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${(props) =>
    props.ocultarSetas &&
    `
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type="number"] {
        -moz-appearance: textfield;
    }
  `}

  .MuiFilledInput-input {
    &:has(input:focus) label {
      padding-top: 0px;
      padding-left: 56px;
    }
  }
`;

export const ContainerAutocomplete = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;

  .icon-tooltip-autocomplete {
    position: absolute;
    right: 0;
    bottom: 15px;
    cursor: pointer;
    z-index: 10;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const AutocompleteCustomizado = styled(Autocomplete, {
  shouldForwardProp: (prop) => prop !== "sxMaxHeight100",
})`
  width: 100%;
  min-height: 56px;
  height: auto;

  .MuiButtonBase-root {
    padding: 10px;
    height: 25px;
    margin-top: 14px;
    margin-right: -5px;
  }

  .MuiSvgIcon-root {
  }

  .Mui-disabled {
    .MuiChip-root {
      opacity: 1;
    }
    ${(props) =>
      !props.theme.temaDarkAtivo &&
      `
      -webkit-text-fill-color: rgba(0, 0, 0, 0.8)!important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `};
  }

  & + .MuiAutocomplete-popper .MuiPaper-root,
  & .MuiAutocomplete-popper .MuiPaper-root,
  .MuiAutocomplete-popper .MuiPaper-root {
    overflow: visible !important;
  }

  & + .MuiAutocomplete-popper .MuiAutocomplete-listbox,
  & .MuiAutocomplete-listbox {
    max-height: ${(props) =>
      props.sxMaxHeight100 ? `${props.sxMaxHeight100}px` : "250px"} !important;
    padding: 0;

    &::-webkit-scrollbar {
      width: 6px !important;
      display: block !important;
    }

    &::-webkit-scrollbar-track {
      background-color: ${({ theme }) => theme.adaptativo("brand20", "brand60")};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.cores.surfaceActionActivePrimary};
      border-radius: 5px;
    }
  }
`;

export const NumericFormatCustomizado = styled.div`
  width: 220px;
  display: flex;
  position: relative;

  .botao {
    margin-top: 3px;
    cursor: pointer;
    font-size: 1rem;
    height: 1rem;
    opacity: 0.5;
    color: ${({ theme }) => theme.cores.textoSimples};
  }

  .botao:hover {
    opacity: 1;
  }

  .sub {
    margin-left: 5px;
    position: absolute;
    left: 0;
    top: 45%;

    @media (max-width: 768px) {
      top: 30%;
    }
  }
  .add {
    margin-right: 5px;
    position: absolute;
    right: 0;
    top: 44%;

    @media (max-width: 768px) {
      top: 28%;
    }
  }

  .subvertical {
    position: absolute;
    right: 6px;
    top: 50%;

    @media (max-width: 768px) {
      top: 30%;
    }
  }
  .addvertical {
    position: absolute;
    right: 6px;
    top: 25%;

    @media (max-width: 768px) {
      top: 28%;
    }
  }

  .MuiInput-input {
    text-align: center;
    font-size: 20px !important;
    padding: 0px 28px;
    padding-top: 15px;

    @media (max-width: 768px) {
      margin-bottom: -1px;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  .Mui-disabled {
    ${(props) =>
      !props.theme.temaDarkAtivo &&
      `
      -webkit-text-fill-color: rgba(0, 0, 0, 0.8)!important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `};
  }
`;

export const NumericFormatCustomizadoVertical = styled(NumericFormatCustomizado)`
  .subvertical {
    position: absolute;
    right: 6px;
    top: 50%;
  }
  .addvertical {
    position: absolute;
    right: 6px;
    top: 25%;
  }

  .MuiInput-input {
    text-align: left;
    font-size: 18px !important;
    padding: 0px 16px;
    padding-top: 15px;

    @media (max-width: 768px) {
      margin-bottom: -1px;
    }
  }
`;

export const NumericFormatInput = styled(NumericFormat)`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  .MuiInputAdornment-root {
    padding-right: 12px;
  }

  label {
    padding-left: ${(props) => (props.value !== "" ? `16px;` : "12px;")};
    ${(props) => props.value !== "" && props.value !== null && `padding-top: 7px;`}
  }

  input {
    padding-left: 12px;
    padding-top: 19px;
    padding-bottom: 5px;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  height: 56px;

  .Mui-disabled {
    ${(props) =>
      !props.theme.temaDarkAtivo &&
      `
      -webkit-text-fill-color: rgba(0, 0, 0, 0.8)!important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `};
  }

  div {
    height: 56px;
  }
`;

export const NumberFormatBaseInput = styled(NumberFormatBase, {
  shouldForwardProp: (prop) => !propsFormatoNumericoNaoEncaminhadas.has(prop),
})`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: 12px;
    ${(props) => props.value && `padding-top: 5px;`};
  }

  input {
    padding-left: 12px;
    padding-top: 19px;
  }

  &:has(input:focus) label {
    padding-top: 5px;
    padding-left: 12px;
  }

  .Mui-Disabled {
    ${(props) =>
      !props.theme.temaDarkAtivo &&
      `
      -webkit-text-fill-color: rgba(0, 0, 0, 0.8)!important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `};
  }

  height: 56px;

  div {
    height: 56px;
  }
`;
export const CampoDeHoraBase = styled(TimePicker)`
  margin-top: 8px;
  width: 100%;
  /* margin-right: 32px; */

  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  @media (max-width: 768px) {
    width: 100%;
    /* margin-bottom: 30px; */
    margin-right: 0px;
  }

  .Mui-disabled {
    ${(props) =>
      !props.theme.temaDarkAtivo &&
      `
      -webkit-text-fill-color: rgba(0, 0, 0, 0.8)!important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `};
  }
`;

export const CampoDeTextoCustom = styled(TextField)`
  width: 100%;
  height: 45px;

  input {
    padding-left: 2px;
    font-family: "Comfortaa", sans-serif;
  }

  div {
    height: 56px;
  }

  .MuiInputBase-root:before {
    ${(props) => props.disabled && `border-bottom: 0px`}
  }

  .MuiInputBase-root {
    height: 29px !important;
  }

  .Mui-disabled {
    ${(props) =>
      !props.theme.temaDarkAtivo &&
      `
      -webkit-text-fill-color: rgba(0, 0, 0, 0.8)!important;
      color: rgba(0, 0, 0, 0.7)!important;
      cursor: not-allowed!important;
    `};
  }
`;

export const InputPorcentagemWayservice = styled(NumberFormatBase)`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: ${(props) => (props.value != "" ? `16px;` : "12px;")};
    ${(props) => props.value !== "" && `padding-top: 7px;`}
  }

  input {
    padding-left: 12px;
    padding-top: 19px;
    font-size: 24px !important;
  }

  &:has(input:focus) label {
    padding-top: 7px;
    padding-left: 16px;
  }

  height: 56px;

  div {
    height: 56px;
  }
`;

export const CampoCorBase = styled(MuiColorInput)`
  width: 100%;
  height: 56px;

  background-color: ${({ theme }) =>
    theme.temaDarkAtivo ? String(theme.cores.neutral100).replace("1)", "0.2)") : "transparent"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  label {
    padding-left: 60px;
    padding-top: 7px;
  }

  input {
    padding-left: 2px;
    padding-top: 19px;
  }

  div {
    height: 56px;
  }

  .Mui-disabled {
    cursor: ${({ typeNumber }) => typeNumber === false && "not-allowed"};
    opacity: ${({ typeNumber }) => (typeNumber === true ? 1 : 0.7)};
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const CustomTooltip = styled(Tooltip)`
  background: transparent;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 99px;
  color: #fff;
`;
